export function useCurrencyUI(): string {
  const config = useRuntimeConfig();

  return (config.public.defaultCurrencyUI as string) || 'kr.';
}
